import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { budgetKeys } from '@/lib/query-keys';
import { financialService } from '@/services/financial.service';

export function useBudgets() {
  const queryClient = useQueryClient();

  const budgetsQuery = useQuery({
    queryKey: budgetKeys.list(),
    queryFn: () => financialService.getBudgets(),
  });

  const createBudget = useMutation({
    mutationFn: (data: Parameters<typeof financialService.createBudget>[0]) => financialService.createBudget(data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: budgetKeys.all }); toast.success('Budget created'); },
    onError: () => toast.error('Failed to create budget'),
  });

  const updateBudget = useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof financialService.updateBudget>[1] }) => financialService.updateBudget(id, data),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: budgetKeys.all }); toast.success('Budget updated'); },
    onError: () => toast.error('Failed to update budget'),
  });

  const deleteBudget = useMutation({
    mutationFn: (id: string) => financialService.deleteBudget(id),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: budgetKeys.all }); toast.success('Budget deleted'); },
    onError: () => toast.error('Failed to delete budget'),
  });

  return {
    budgets: budgetsQuery.data?.data ?? [],
    isLoading: budgetsQuery.isLoading,
    createBudget, updateBudget, deleteBudget,
  };
}
